import axios from 'axios';

import { config } from '@/config/Config';

const BASE = `${config.serverBaseUrl}/v1/web`;

export const webRequest = async (gameId, { method, path, data, params }) => {
    const headers = { 'Content-Type': 'application/json', ...(gameId ? { 'X-Web-Game-Id': gameId } : {}) };
    try {
        return (await axios({ method, url: `${BASE}${path}`, headers, params, data })).data;
    } catch (error) {
        if (error.response?.status !== 404) {
            console.error(`Live services: ${method.toUpperCase()} ${path} failed:`, error.response?.data || error.message);
        }
        throw error;
    }
};

export const nullOn404 = async (work) => {
    try {
        return await work();
    } catch (e) {
        if (e?.response?.status === 404) return null;
        throw e;
    }
};
